// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LeaseGraderRouteImport } from './routes/lease-grader'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as DisclosuresRouteImport } from './routes/disclosures'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ProtectedRouteRouteImport } from './routes/_protected/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CommunityTheaterIndexRouteImport } from './routes/community-theater/index'
import { Route as BrowseIndexRouteImport } from './routes/browse/index'
import { Route as TtwSlugRouteImport } from './routes/ttw/$slug'
import { Route as LandlordUnderwritableEntityRouteImport } from './routes/landlord/$underwritableEntity'
import { Route as CallbackSsoRouteImport } from './routes/callback/sso'
import { Route as CallbackAuthRouteImport } from './routes/callback/auth'
import { Route as ProtectedProfileRouteImport } from './routes/_protected/profile'
import { Route as ProtectedOnboardingRouteImport } from './routes/_protected/onboarding'
import { Route as ProtectedAdminRouteRouteImport } from './routes/_protected/admin/route'
import { Route as ExploreCatskillsIndexRouteImport } from './routes/explore/catskills/index'
import { Route as ProtectedConnectIndexRouteImport } from './routes/_protected/connect/index'
import { Route as ProtectedProfileIndexRouteImport } from './routes/_protected/profile/index'
import { Route as ProtectedProfileUserRouteImport } from './routes/_protected/profile/user'
import { Route as ProtectedProfileTtwEditorRouteImport } from './routes/_protected/profile/ttw-editor'
import { Route as ProtectedProfileSmbRouteImport } from './routes/_protected/profile/smb'
import { Route as ProtectedProfileInvRouteImport } from './routes/_protected/profile/inv'
import { Route as ProtectedProfileComposeRouteImport } from './routes/_protected/profile/compose'
import { Route as ProtectedOnboardingIndexRouteImport } from './routes/_protected/onboarding/index'
import { Route as ProtectedOnboardingSmbRouteImport } from './routes/_protected/onboarding/smb'
import { Route as ProtectedOnboardingInvRouteImport } from './routes/_protected/onboarding/inv'
import { Route as ProtectedAdminIndexRouteImport } from './routes/_protected/admin/index'
import { Route as ProtectedAdminSmbBrandIdRouteImport } from './routes/_protected/admin/smb/$brandId'
import { Route as ProtectedAdminStylingFormIndexRouteImport } from './routes/_protected/admin/styling/form/index'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const LeaseGraderRoute = LeaseGraderRouteImport.update({
            id: '/lease-grader',path: '/lease-grader',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ErrorRoute = ErrorRouteImport.update({
            id: '/error',path: '/error',getParentRoute: () => rootRouteImport
          })
const DisclosuresRoute = DisclosuresRouteImport.update({
            id: '/disclosures',path: '/disclosures',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CommunityTheaterIndexRoute = CommunityTheaterIndexRouteImport.update({
            id: '/community-theater/',path: '/community-theater/',getParentRoute: () => rootRouteImport
          })
const BrowseIndexRoute = BrowseIndexRouteImport.update({
            id: '/browse/',path: '/browse/',getParentRoute: () => rootRouteImport
          })
const TtwSlugRoute = TtwSlugRouteImport.update({
            id: '/ttw/$slug',path: '/ttw/$slug',getParentRoute: () => rootRouteImport
          })
const LandlordUnderwritableEntityRoute = LandlordUnderwritableEntityRouteImport.update({
            id: '/landlord/$underwritableEntity',path: '/landlord/$underwritableEntity',getParentRoute: () => rootRouteImport
          })
const CallbackSsoRoute = CallbackSsoRouteImport.update({
            id: '/callback/sso',path: '/callback/sso',getParentRoute: () => rootRouteImport
          })
const CallbackAuthRoute = CallbackAuthRouteImport.update({
            id: '/callback/auth',path: '/callback/auth',getParentRoute: () => rootRouteImport
          })
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedOnboardingRoute = ProtectedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedAdminRouteRoute = ProtectedAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => ProtectedRouteRoute
          })
const ExploreCatskillsIndexRoute = ExploreCatskillsIndexRouteImport.update({
            id: '/explore/catskills/',path: '/explore/catskills/',getParentRoute: () => rootRouteImport
          })
const ProtectedConnectIndexRoute = ProtectedConnectIndexRouteImport.update({
            id: '/connect/',path: '/connect/',getParentRoute: () => ProtectedRouteRoute
          })
const ProtectedProfileIndexRoute = ProtectedProfileIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedProfileRoute
          })
const ProtectedProfileUserRoute = ProtectedProfileUserRouteImport.update({
            id: '/user',path: '/user',getParentRoute: () => ProtectedProfileRoute
          })
const ProtectedProfileTtwEditorRoute = ProtectedProfileTtwEditorRouteImport.update({
            id: '/ttw-editor',path: '/ttw-editor',getParentRoute: () => ProtectedProfileRoute
          })
const ProtectedProfileSmbRoute = ProtectedProfileSmbRouteImport.update({
            id: '/smb',path: '/smb',getParentRoute: () => ProtectedProfileRoute
          })
const ProtectedProfileInvRoute = ProtectedProfileInvRouteImport.update({
            id: '/inv',path: '/inv',getParentRoute: () => ProtectedProfileRoute
          })
const ProtectedProfileComposeRoute = ProtectedProfileComposeRouteImport.update({
            id: '/compose',path: '/compose',getParentRoute: () => ProtectedProfileRoute
          })
const ProtectedOnboardingIndexRoute = ProtectedOnboardingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedOnboardingRoute
          })
const ProtectedOnboardingSmbRoute = ProtectedOnboardingSmbRouteImport.update({
            id: '/smb',path: '/smb',getParentRoute: () => ProtectedOnboardingRoute
          })
const ProtectedOnboardingInvRoute = ProtectedOnboardingInvRouteImport.update({
            id: '/inv',path: '/inv',getParentRoute: () => ProtectedOnboardingRoute
          })
const ProtectedAdminIndexRoute = ProtectedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedAdminRouteRoute
          })
const ProtectedAdminSmbBrandIdRoute = ProtectedAdminSmbBrandIdRouteImport.update({
            id: '/smb/$brandId',path: '/smb/$brandId',getParentRoute: () => ProtectedAdminRouteRoute
          })
const ProtectedAdminStylingFormIndexRoute = ProtectedAdminStylingFormIndexRouteImport.update({
            id: '/styling/form/',path: '/styling/form/',getParentRoute: () => ProtectedAdminRouteRoute
          })





const ProtectedAdminRouteRouteChildren = {
  ProtectedAdminIndexRoute: ProtectedAdminIndexRoute,ProtectedAdminSmbBrandIdRoute: ProtectedAdminSmbBrandIdRoute,ProtectedAdminStylingFormIndexRoute: ProtectedAdminStylingFormIndexRoute
}

const ProtectedAdminRouteRouteWithChildren = ProtectedAdminRouteRoute._addFileChildren(ProtectedAdminRouteRouteChildren)




const ProtectedOnboardingRouteChildren = {
  ProtectedOnboardingInvRoute: ProtectedOnboardingInvRoute,ProtectedOnboardingSmbRoute: ProtectedOnboardingSmbRoute,ProtectedOnboardingIndexRoute: ProtectedOnboardingIndexRoute
}

const ProtectedOnboardingRouteWithChildren = ProtectedOnboardingRoute._addFileChildren(ProtectedOnboardingRouteChildren)




const ProtectedProfileRouteChildren = {
  ProtectedProfileComposeRoute: ProtectedProfileComposeRoute,ProtectedProfileInvRoute: ProtectedProfileInvRoute,ProtectedProfileSmbRoute: ProtectedProfileSmbRoute,ProtectedProfileTtwEditorRoute: ProtectedProfileTtwEditorRoute,ProtectedProfileUserRoute: ProtectedProfileUserRoute,ProtectedProfileIndexRoute: ProtectedProfileIndexRoute
}

const ProtectedProfileRouteWithChildren = ProtectedProfileRoute._addFileChildren(ProtectedProfileRouteChildren)



const ProtectedRouteRouteChildren = {
  ProtectedAdminRouteRoute: ProtectedAdminRouteRouteWithChildren,ProtectedOnboardingRoute: ProtectedOnboardingRouteWithChildren,ProtectedProfileRoute: ProtectedProfileRouteWithChildren,ProtectedConnectIndexRoute: ProtectedConnectIndexRoute
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(ProtectedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ProtectedRouteRoute: ProtectedRouteRouteWithChildren,SplatRoute: SplatRoute,AboutUsRoute: AboutUsRoute,DisclosuresRoute: DisclosuresRoute,ErrorRoute: ErrorRoute,FaqRoute: FaqRoute,LeaseGraderRoute: LeaseGraderRoute,LogoutRoute: LogoutRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,CallbackAuthRoute: CallbackAuthRoute,CallbackSsoRoute: CallbackSsoRoute,LandlordUnderwritableEntityRoute: LandlordUnderwritableEntityRoute,TtwSlugRoute: TtwSlugRoute,BrowseIndexRoute: BrowseIndexRoute,CommunityTheaterIndexRoute: CommunityTheaterIndexRoute,ExploreCatskillsIndexRoute: ExploreCatskillsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)